import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';

export function displayBillItemMetric(metric: number | null | undefined, percentage: boolean = false): string {
    if (isNull(metric) || isUndefined(metric)) return '-';

    if (percentage) {
        return `${metric.toLocaleString()} %`;
    }

    return metric.toFixed(2);
}
